import {createReducer, on} from "@ngrx/store";
import {IGetCategoriesItemDto} from "../../main/pages/categories.dto";
import * as CategoriesActions from "./../actions/categories.actions";
import {HttpActionState} from "../../main/pages/users/userslisting/store/users-listing.reducers";

export interface ICategoriesState {
    categories: IGetCategoriesItemDto[]
    fetchCategoriesRequestState: HttpActionState,
}

const initialState: ICategoriesState = {
    categories: [],
    fetchCategoriesRequestState: HttpActionState.Init
};

export const categoriesReducer = createReducer(initialState,
    on(CategoriesActions.fetchCategories, (state) => ({
        ...state,
        fetchCategoriesRequestState: HttpActionState.Busy
    })),
    on(CategoriesActions.fetchCategoriesSuccess, (state, {categories}) => ({
        ...state,
        categories: categories,
        fetchCategoriesRequestState: HttpActionState.Done
    })),
    on(CategoriesActions.fetchCategoriesFailure, (state) => ({
        ...state,
        fetchCategoriesRequestState: HttpActionState.Failed
    }))
);